import {Action} from '@ngrx/store';
import {EnclosureCardsState} from '../states/enclosure-cards-state';
import {GetEnclosureCardSuccessAction} from '../actions/enclosure-cards/get-enclosure-card-success-action';
import {GetEnclosureCardErrorAction} from '../actions/enclosure-cards/get-enclosure-card-error-action';
import {UpdateEnclosureCardAction} from '../actions/enclosure-cards/update-enclosure-card-action';
import {UpdateEnclosureCardErrorAction} from '../actions/enclosure-cards/update-enclosure-card-error-action';
import {GetEnclosureCardAction} from '../actions/enclosure-cards/get-enclosure-card-action';
import {Deserialize, Serialize} from 'cerialize';

const initialState = new EnclosureCardsState();

export function EnclosureCardsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: EnclosureCardsState = Deserialize(serializedState, EnclosureCardsState);

  switch (action.type) {
    case GetEnclosureCardAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetEnclosureCardSuccessAction.type:
      state.ready = true;
      state.error = null;
      state.enclosureCards[(<GetEnclosureCardSuccessAction>action).enclosureCard.groupId] = (<GetEnclosureCardSuccessAction>action).enclosureCard;
      break;

    case GetEnclosureCardErrorAction.type:
      state.ready = true;
      state.error = (<GetEnclosureCardErrorAction>action).error;
      break;

    case UpdateEnclosureCardAction.type:
      state.ready = false;
      state.error = null;
      break;

    case UpdateEnclosureCardErrorAction.type:
      state.ready = true;
      state.error = (<UpdateEnclosureCardErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
